/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Task_TitleInputs */

const cs_field_task_title = /** @type {(inputs: Field_Task_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název úkolu`)
};

const en_field_task_title = /** @type {(inputs: Field_Task_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task title`)
};

/**
* | output |
* | --- |
* | "Task title" |
*
* @param {Field_Task_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_task_title = /** @type {((inputs?: Field_Task_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Task_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_task_title(inputs)
	return cs_field_task_title(inputs)
});